/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The data-ids used in the edit tool dialog component.
 * @export
 */
export const EDIT_TOOL_DATA_IDS = {
  cancelButton: `Dialog button: Cancel`,
  contentToolEnabled: `Form field: Content tool name`,
  contentToolInstructions: `Form field: Content tool name`,
  contentToolName: `Form field: Content tool name`,
  contentToolTags: `Form field: Content tool tags`,
  saveButton: `Dialog button: Save`,
};

/**
 * The form field ids used in the edit tool dialog component.
 * @export
 */
export const EDIT_TOOL_FORM_IDS = {
  contentToolAuthType: `content-tool-auth-type`,
  contentToolEditButton: `content-tool-edit`,
  contentToolEnabled: `content-tool-enabled`,
  contentToolInstructions: `content-tool-instructions`,
  contentToolName: `content-tool-name`,
  contentToolTags: `content-tool-tags`,
};
